export function initTabsPlugin() {
    // Controlliamo se esiste almeno un elemento con la nostra classe "hook"
    if (document.querySelector('.js-tabs-wrapper')) {
        // Import dinamico del file di logica
        import('./tabs.js')
            .then(module => module.default())
            .catch(err => console.error("Errore nel caricamento del plugin Tabs:", err));
    }
}
